$(document).ready(function () {

    
  /* 18/01/22 cart delevery method tipsy */
  	$(".faced-store .js-open-tipsy.checkout__link").hover(function () {
      $(this).closest('div').find(".tipsy").toggleClass("left").toggleClass("bottom");
      $(this).closest('div').find(".tipsy").addClass("show");
      $(this).closest('div').find(".tipsy").removeClass( "hide" ); 
      //$(this).addClass("show");  
  });

    $(".tipsy-close").on('click', function(e) {
      $(".faced-store .tipsy").removeClass( "show" );
      $(".faced-store .tipsy").addClass( "hide" );
    });
  

       $(".faced-store .tipsy").mouseleave(function(){
            $(".faced-store .tipsy").removeClass( "show" );
            $(".faced-store .tipsy").addClass( "hide" );
      });
  
       $(".faced-store .js-open-tipsy").mouseleave(function(){
          setTimeout(function(){
            if($(".faced-store .tipsy:hover").length == 0){
          $(".faced-store .tipsy").removeClass( "show" );
          $(".faced-store .tipsy").addClass( "hide" );
            }
            }, 300);

    	});

  /* 18/01/22 cart delevery method tipsy end */

    
      var currentSelectedLang = $('.wgcurrent.wg-li.wg-flags.flag-1').data('l');
        if(typeof currentSelectedLang == "undefined"){
        currentSelectedLang = "en";
    }

    translateCart(currentSelectedLang);
  
        Weglot.on("languageChanged", function(newLang, prevLang) {
            translateCart(newLang);
        });


    function translateCart(currentSelectedLangVar){
    if (typeof currentSelectedLangVar == "undefined") {
        englishTranslation();
    }else if (currentSelectedLangVar == 'en') {
        englishTranslation();
    } else if (currentSelectedLangVar == 'tw') {
        taiwanTranslation();
    }
  }

     function englishTranslation(){
         $("#errorInfo").text("Please select a store retailer");
         $("#state").text("state");
         $('#storelocator-query').attr('placeholder','Enter Zip Code');
        $(".allstorestate").html("Please select state");
        $(".checkout-errorinfo").html("Please select a store retailer");

     }
  
    function taiwanTranslation(){
        $("#errorInfo").text("請選擇以下授權經銷商");
        $('#storelocator-query').attr('placeholder','輸入地址或郵政編碼');
        $("#state").text("縣市");
        $(".allstorestate").html("請選擇縣市");
        $(".checkout-errorinfo").html("請選擇店家");
    };
  
  });